import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "@env/environment";
import { ApiRoutes } from "app/core/constants/api-routes";
import {
  AvailableSchedulesApiResponse,
  ServiceRescheduleRequest,
  ServiceRescheduleResponse,
  ServiceRescheduleResponseData,
} from "../models/service-reschedule.model";

@Injectable({ providedIn: "root" })
export class ServiceRescheduleDataService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API_RESCHEDULE;

  async fetchAvailableSchedules(
    tenantId: string,
    serviceId: string,
  ): Promise<string[]> {
    const url = `${this.baseUrl}${ApiRoutes.service.rescheduling.availableDates(tenantId)}`;
    const params = new HttpParams().set("os-id", serviceId);

    const response = await firstValueFrom(
      this.http.get<AvailableSchedulesApiResponse>(url, { params }),
    );

    return response.code === 1 ? response.data : [];
  }

  async rescheduleService(
    tenantId: string,
    request: ServiceRescheduleRequest,
  ): Promise<ServiceRescheduleResponseData> {
    const url = `${this.baseUrl}${ApiRoutes.service.rescheduling.submit(
      tenantId,
      request.childId,
    )}`;

    try {
      const response = await firstValueFrom(
        this.http.post<ServiceRescheduleResponse>(url, request, {
          observe: "response",
        }),
      );

      if (response.status === 200 && response.body) {
        return {
          success: true,
          message:
            response.body.message || "Servicio reprogramado exitosamente",
        };
      }

      throw new Error("Unexpected response from server");
    } catch (error: any) {
      if (error?.status === 409) {
        const businessError = Object.assign(
          new Error(
            error?.error?.message || "Service not allowed for rescheduling",
          ),
          { code: 2, status: 409 },
        );
        throw businessError;
      }

      if (error?.status === 500) {
        throw new Error("Server error during service rescheduling");
      }

      throw error;
    }
  }
}
